import { Log } from '../../shared/log';
import { Injectable } from '@angular/core';
import { AppConfig } from '../../app.config';
import { ITokenInfo } from './token-info.interface';
import { AuthTokenService } from './auth-token.service';
import * as md5 from 'md5';
import {KeycloakConfig} from './keycloak-config';

const log = new Log('TokenService');

// Public Interface of Token Info Service
export interface TokenInfoServiceI {
   getSavedTokenInfo(): ITokenInfo;
   checkTokenShared(): boolean;
}

@Injectable()
export class TokenInfoService implements TokenInfoServiceI {

  private savedTokenInfo: ITokenInfo;

  constructor(
    private appConfig: AppConfig,
    private authTokenService: AuthTokenService,
    private keycloakConfigHolder: KeycloakConfig
  ) { }

  public getSavedTokenInfo(): ITokenInfo {
    if (this.savedTokenInfo) {
      return this.savedTokenInfo;
    }
    try {
    this.savedTokenInfo = this.getTokenInfo()
    return this.savedTokenInfo;
    } catch (error) {
      log.error('Failed to get token info', error);
      throw error;
    }
  }

  /**
   * Returns true if details are shared, ie name or date of birth
   */
  public checkTokenShared(): boolean {
    try {
      const tokenInfo = this.getSavedTokenInfo();
      return !!(tokenInfo && tokenInfo.Nickname);
    } catch (error) {
      log.error('Failed to check token shared', error);
      return false;
    }
  }

  private getTokenInfo(): ITokenInfo {
    const data = this.keycloakConfigHolder.keyCloakInstance.tokenParsed;
    if (data === undefined) {
      throw new Error('Not Authenticated');
    }

    this.savedTokenInfo = {
      Email: data['email'],
      AuthenticationMethod: data['email'],
      Picture: 'https://www.gravatar.com/avatar/' + md5(data['email'].toLowerCase().trim()),
      DateOfBirth: data['birthdate']  !== null ? data['birthdate'] : null,
      FamilyName: data['family_name'],
      FirstName: data['given_name'],
      MiddleName: data['middle_name'],
      Nickname: data['email'],
      QID:  data['qid'],
      UserId:  data['sub'],
      principalId: data['sub'],
      Name: data['name'],
    };

    console.log(this.savedTokenInfo);
    return this.savedTokenInfo;
  }

}



// WEBPACK FOOTER //
// ./app/services/auth/token-info.service.ts